export default __webpack_public_path__ + "static/media/flap_char.5302f115.png";